<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve"
       version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 131492 131492"
       xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <rect class="fil0" width="131492" height="131492" rx="12823" ry="12823" />
   <rect class="fil1 str0" x="16573" y="16575" width="98344" height="98344" rx="9163" ry="9163" />
 </g>
</svg>
</template>

<script>
export default {
  name: 'SwitchSingle',
};
</script>

<style scoped>
.str0 {
  stroke: #FEFEFE;
  stroke-width: 5986.99
}

.fil1 {
  fill: none
}

.fil0 {
  fill: #CCCCCC
}
</style>
